<section class="home wrap border-bottom" [class.compact-hero]="isLoggedIn" [class.py-4]="isLoggedIn" [class.py-lg-5]="!isLoggedIn">
  <div class="container">
    <div class="mx-auto hero-wrap">
      @if (!isLoggedIn) {
        <h1 class="hero-title mb-1">
          With the help of AI no more pointless interviews to do
        </h1>
        <p class="hero-sub mb-5">
          Our skill quizes reduce rounds of interviews you need to do and our AI model evaluates your answers
        </p>
      }

      <div class="search-shell d-flex flex-column flex-lg-row overflow-hidden" [class.mb-0]="isLoggedIn"
            [class.mb-5]="!isLoggedIn">
            <div class="search-part d-flex align-items-center px-3 py-2 flex-grow-1">
                <i class="bi bi-search me-2 search-icon"></i>
                <input type="text" [formControl]="freeTextControl"
                    class="form-control border-0 shadow-none p-0 search-input"
                    placeholder="What kind of job you'd like?" />
            </div>

            <div class="search-part search-part-location d-flex align-items-center px-3 py-2">
                <i class="bi bi-geo-alt me-2 search-icon"></i>
                <input type="text" [formControl]="locationControl"
                    class="form-control border-0 shadow-none p-0 search-input" placeholder="Where?" />
            </div>

            <button class="btn search-btn px-4 px-lg-5 py-2 rounded-0" (click)="search()">
                Search
            </button>
        </div>
      @if (!isLoggedIn) {
        <div class="promo-card p-3 p-md-4 promo-pad-lg">
          <div class="row g-4 align-items-center">
            <div class="col-12 col-lg-7">
              <h2 class="promo-title mb-4">
                Create a profile and find a job that suits you with the help of Merit
              </h2>

              <div class="d-flex mb-3">
                <i class="bi bi-check-circle offer-icon me-2"></i>
                <div>
                  <h3 class="offer-title mb-1">Potential offers from employers</h3>
                  <p class="offer-text mb-0">
                    Employers see your account in the database and can offer positions
                  </p>
                </div>
              </div>

              <div class="d-flex mb-3">
                <i class="bi bi-stars offer-icon me-2"></i>
                <div>
                  <h3 class="offer-title mb-1">Advertisements based on your CV</h3>
                  <p class="offer-text mb-0">
                    Submit your CV and based on your portfolio get offers you might be interested in
                  </p>
                </div>
              </div>

              <div class="d-flex mb-4">
                <i class="bi bi-lightning-charge offer-icon me-2"></i>
                <div>
                  <h3 class="offer-title mb-1">Quick submission to job advertisements</h3>
                  <p class="offer-text mb-0">
                    Submit your application with a single click
                  </p>
                </div>
              </div>

              <button class="btn create-btn px-4 py-2" routerLink="/register">Create your profile</button>
            </div>

            <div class="col-12 col-lg-5 text-center">
              <img
                src="Assets/Phone.png"
                alt="Merit app preview"
                class="img-fluid phone-preview"
              />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>


